import axios from 'axios';
import { baseUrl, HttpMethods } from './base';
import type { IGetClientAccountServiceRes, IPatchClientAccountPayload } from './SageAdmin/ClientAccount/types';

export type SettingsAccountResponse = IGetClientAccountServiceRes;
export type SettingsAccountPatchPayload = Partial<IPatchClientAccountPayload>;

interface SettingsAccountRequest {
  accountId: number;
  isSystemAdmin: boolean;
}

interface PatchSettingsAccountRequest extends SettingsAccountRequest {
  data: SettingsAccountPatchPayload;
}

function getSettingsAccountPath({ accountId, isSystemAdmin }: SettingsAccountRequest): string {
  return isSystemAdmin ? `${baseUrl.OS}/accounts/${accountId}` : `${baseUrl.SHERPA}/accounts/current`;
}

export async function getSettingsAccount(request: SettingsAccountRequest): Promise<SettingsAccountResponse> {
  const res = await axios.request<SettingsAccountResponse>({
    method: HttpMethods.GET,
    url: getSettingsAccountPath(request),
  });
  return res.data;
}

export async function patchSettingsAccount({ data, ...request }: PatchSettingsAccountRequest) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: getSettingsAccountPath(request),
    data,
  });
  return res.data;
}

export async function patchSettingsAccountLogo(request: SettingsAccountRequest, logoImage: unknown) {
  return patchSettingsAccount({
    ...request,
    data: { logoImage } as SettingsAccountPatchPayload,
  });
}
